module.exports = "<div class=\"home-wrapper\">\r\n\r\n  <form action=\"\">\r\n\r\n    <div class=\"form-item\">\r\n      <div class=\"label\">enter username</div>\r\n      <input class=\"custom-input\" type=\"text\"  >\r\n\r\n    </div>\r\n\r\n    <div class=\"form-item\">\r\n      <div class=\"label\">enter password</div>\r\n      <input class=\"custom-input\" type=\"text\"  >\r\n\r\n    </div>\r\n    <button [routerLink]=\"['/step1']\" queryParamsHandling=\"merge\">kupi online</button>\r\n\r\n  </form>\r\n\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home-login/home.component.html
// module id = ./src/app/pages/home-login/home.component.html
// module chunks = main